import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $initialCurrenciesAvailableStore } from '@lib/store';
import type { IntegrationType } from '@shared/api';
import { Select, Text } from '@shared/widgets';
import xeroImg from '@assets/icons/integrations/xero-logo.svg?url';

interface IIntegrationTitleProps {
  name: IntegrationType;
  currency?: string;
  onChangeCurrency: (currency: string | undefined) => void;
}

export const IntegrationTitle = (props: IIntegrationTitleProps) => {
  const currenciesAvailableStore = useUnit($initialCurrenciesAvailableStore.store);

  const { t } = useTranslation('integration');

  return (
    <div className='-z-1 mb-6 flex flex-wrap items-center justify-between gap-2'>
      <div className='flex items-center'>
        <img className='mr-4 h-10 w-10' src={xeroImg} alt='Xero' />
        <Text className='grow-1' size='2xl'>
          {t('header.title', { name: props.name })}
        </Text>
      </div>
      <div className='w-fit'>
        <Select
          className='min-w-[160px]'
          items={currenciesAvailableStore.data}
          nullValue={{ isEnable: true, text: t('placeholders.allCurrencies', { ns: 'common' }) }}
          value={props.currency}
          onChange={props.onChangeCurrency}
        />
      </div>
    </div>
  );
};
